/*
  Flowkeeper - Pomodoro timer for power users and teams
  Copyright (c) 2023 Constantine Kulak, Geoffrey Espagne

  This program is free software: you can redistribute it and/or modify
  it under the terms of the GNU General Public License as published by
  the Free Software Foundation; either version 3 of the License, or
  (at your option) any later version.

  This program is distributed in the hope that it will be useful,
  but WITHOUT ANY WARRANTY; without even the implied warranty of
  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
  GNU General Public License for more details.

  You should have received a copy of the GNU General Public License
  along with this program.  If not, see <https://www.gnu.org/licenses/>.
*/

import axios from 'axios';
const Cookies = require("js-cookie");

function getServerUri() {
    const host = `${window.location.protocol}//${window.location.hostname}`;
    const port = window.location.port;
    if (port) {
        return `${host}:${port}`;
    } else {
        return host;
    }
}

function getToken(clientId: string, code?: string) {
    const body = [];

    let grantType;
    if (code) {
        grantType = "authorization_code";
        body.push(`code=${ code }`);
    } else {
        grantType = "refresh_token";
        body.push(`refresh_token=${ Cookies.get('fw-utoken') }`);
    }

    body.push(`client_id=${ clientId }`);
    body.push(`grant_type=${ grantType }`);
    body.push(`redirect_uri=${ getServerUri() }`);

    return axios.post(`${getServerUri()}/token`, body.join("&"), getTokenRequestHeaders())
        .then(response => {
            if (response.status !== 200) {
                return Promise.reject(new Error(`OAuth token request failed with HTTP ${ response.status }`));
            }
            if (response.data.error) {
                return Promise.reject(new Error(`Invalid OAuth token request: ${ response.data.error_description }`));
            }
            const decodedToken = decodeIdToken(response.data.id_token);
            return [response.data, decodedToken];
        })
        .catch((error) => {
            console.error('sendTokenRequest error', error)
            return Promise.reject(error);
        });
}

export const sendTokenRequest = (code?: string) => {
    return axios.get(`${getServerUri()}/config`)
        .then(response => {
            if (response.status !== 200) {
                return Promise.reject(new Error(`Configuration request failed with HTTP ${ response.status }`));
            }
            const client_id = response.data['client_id'];
            return getToken(client_id, code);
        })
        .catch((error) => {
            console.error('sendTokenRequest error', error)
            return Promise.reject(error);
        });
}

const getTokenRequestHeaders = () => {
    return {
        headers: {
            "Accept": "application/json",
            "Content-Type": "application/x-www-form-urlencoded"
        }
    };
};

const decodeIdToken = (token: string) => {
    return JSON.parse(atob(token.split(".")[1]));
};